import {combine} from 'effector';

import {clearDocumentsGridCache, fetchDocumentsGrid} from 'api';
import {createGridListModel} from 'core/hooks/grid2.0';
import {rootDomain} from 'core/rootDomain';
import {DocumentsGridRawRow} from 'types';
import {SimplePaginationContent} from 'types/api';

const domain = rootDomain.createDomain('DocumentsGridListDomain');

export const fetchDataFx = domain.createEffect({
    name: 'fetchDataFx',
    handler: fetchDocumentsGrid,
});

export const clearDataCacheFx = domain.createEffect({
    name: 'clearDataCacheFx',
    handler: clearDocumentsGridCache,
});

export const {
    Gate,
    pageNumber$,
    pageNumberChanged,
    pageIncremented,
    pageSize$,
    pageSizeChanged,
    filters$,
    filtersChanged,
    filtersSubmit,
    filtersReset,
    sortings$,
    sortingsChanged,
    sortingsReset,
    listStateChanged,
    showConfigBlock$,
    showConfigBlockChanged,
    stateReset,
} = createGridListModel({domain});

export const data$ = domain.createStore<SimplePaginationContent<DocumentsGridRawRow> | null>(null);

export const searchChanged = domain.createEvent<string>();
export const search$ = domain.createStore<string>('').on(searchChanged, (_, value) => value);

export const updOnlyChanged = domain.createEvent<boolean>();
export const updOnly$ = domain.createStore<boolean>(false).on(updOnlyChanged, (_, value) => value);

export const listState$ = combine({
    data: data$,
    filters: filters$,
    sortings: sortings$,
    search: search$,
    updOnly: updOnly$,
    showConfigBlock: showConfigBlock$,
    dataLoading: fetchDataFx.pending,
});
